import * as yup from "yup";

export function AddEditBankAccountSchema() {
  return yup
    .object({
      bankId: yup.number().required("نام بانک خود را وارد کنید"),
      accountOwnerName: yup.string().required("نام صاحب حساب را وارد کنید"),
      accountNumber: yup.string().required("شماره حساب را وارد کنید"),
      shabaNumber: yup.string().required("شماره شبا را وارد کنید "),
      cardNumber: yup.string().required("شماره کارت را وارد کنید"),
    })
    .required();
}
